import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Navigation from './Navigation';
import { BottomTabNavigation } from './MobileNavigation';
import OfflineStatusIndicator from '@/components/UI/OfflineStatusIndicator';

export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex pt-16"> {/* Add top padding to account for fixed header */}
        <Navigation />
        <main className="flex-1 p-4 lg:p-6 lg:ml-64 pb-20 lg:pb-4"> {/* Add bottom padding for mobile nav */}
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <BottomTabNavigation />
    </div>
  );
}
